import { useParams } from "react-router-dom";
import { API_PATHS } from "@/constants";
import FullScreenLoader from "@/components/FullScreenLoader";
import { useLoadQuizBlocks } from "@/hooks/useLoadQuizBlocks";
import { QuizContextProvider } from "@/pages/quiz/context";
import { QuizV1 } from "@/pages/quiz/base";

const WAIVER_QUIZ_ID = "5";

const WaiverPage = () => {
  const { voucherId } = useParams();

  const { loading, quizBlocks } = useLoadQuizBlocks(
    API_PATHS.QUIZ_BLOCKS(WAIVER_QUIZ_ID),
  );

  if (loading || !voucherId) {
    return <FullScreenLoader isLoading={loading} />;
  }

  return (
    <QuizContextProvider questions={quizBlocks} voucherId={voucherId}>
      <QuizV1 />
    </QuizContextProvider>
  );
};

export default WaiverPage;
